export default __webpack_public_path__ + "static/media/img--legend.2578b37a.png";